import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';
import { FileText } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#F5F7FA]">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_mercamove/artifacts/ch8knfdf_Move_Logo_wHT.png" 
                alt="Mercapoli Move"
                className="h-8"
              />
            </Link>
            <div className="flex items-center gap-4">
              <Link to="/login">
                <Button variant="ghost" className="text-slate-700 hover:text-[#00BFA6]">
                  Iniciar Sesión
                </Button>
              </Link>
              <Link to="/register">
                <Button className="btn-primary px-6 py-2 text-sm">
                  Registrarse
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12">
            <div className="flex items-center gap-3 mb-6">
              <FileText className="w-8 h-8 text-[#00BFA6]" />
              <h1 className="text-3xl font-bold text-slate-900 font-['Outfit']">
                Términos de Servicio
              </h1>
            </div>
            <p className="text-slate-500 mb-8">Última actualización: Enero 2025</p>

            <div className="prose prose-slate max-w-none">
              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">1. Aceptación de los Términos</h2>
              <p className="text-slate-600 mb-4">
                Al acceder y utilizar la plataforma Mercapoli Move ("la Plataforma"), usted acepta estar 
                sujeto a estos Términos de Servicio. Si no está de acuerdo con alguna parte de estos 
                términos, no podrá acceder al servicio.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">2. Descripción del Servicio</h2>
              <p className="text-slate-600 mb-4">
                Mercapoli Move es una plataforma tecnológica que conecta a usuarios con servicios de:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Transporte de pasajeros (ride-hailing)</li>
                <li>Renta de vehículos (car sharing)</li>
                <li>Servicios de logística y mensajería</li>
                <li>Servicios de pago digital (Digi Wallet)</li>
              </ul>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">3. Registro y Cuenta de Usuario</h2>
              <p className="text-slate-600 mb-4">
                Para utilizar nuestros servicios, debe crear una cuenta proporcionando información 
                precisa y completa. Usted es responsable de mantener la confidencialidad de su cuenta 
                y contraseña, y acepta la responsabilidad de todas las actividades que ocurran bajo 
                su cuenta.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">4. Uso del Servicio</h2>
              <p className="text-slate-600 mb-4">
                Usted se compromete a utilizar la Plataforma únicamente para fines legales y de 
                acuerdo con estos Términos. Está prohibido:
              </p>
              <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
                <li>Usar el servicio para actividades ilegales</li>
                <li>Proporcionar información falsa o engañosa</li>
                <li>Interferir con el funcionamiento de la Plataforma</li>
                <li>Acceder a cuentas de otros usuarios sin autorización</li>
                <li>Usar el servicio para acosar, amenazar o dañar a otros</li>
              </ul>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">5. Pagos y Tarifas</h2>
              <p className="text-slate-600 mb-4">
                Los precios de los servicios se muestran antes de confirmar cada solicitud. 
                Mercapoli Move se reserva el derecho de modificar las tarifas en cualquier momento. 
                Los pagos se procesan a través de Digi Wallet, tarjetas de crédito/débito o tokens DIGGII.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">6. Cancelaciones y Reembolsos</h2>
              <p className="text-slate-600 mb-4">
                Las políticas de cancelación varían según el tipo de servicio. Los reembolsos se 
                procesarán de acuerdo con las circunstancias específicas de cada caso y las políticas 
                vigentes al momento de la solicitud.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">7. Limitación de Responsabilidad</h2>
              <p className="text-slate-600 mb-4">
                Mercapoli Move actúa como intermediario tecnológico. No somos responsables de las 
                acciones u omisiones de los conductores, propietarios de vehículos o usuarios. 
                Nuestra responsabilidad se limita al monto pagado por el servicio en cuestión.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">8. Propiedad Intelectual</h2>
              <p className="text-slate-600 mb-4">
                Todo el contenido de la Plataforma, incluyendo textos, gráficos, logotipos, iconos, 
                imágenes y software, es propiedad de Mercapoli o sus licenciantes y está protegido 
                por las leyes de propiedad intelectual.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">9. Modificaciones</h2>
              <p className="text-slate-600 mb-4">
                Nos reservamos el derecho de modificar estos Términos en cualquier momento. Las 
                modificaciones entrarán en vigor inmediatamente después de su publicación en la 
                Plataforma. El uso continuado del servicio constituye la aceptación de los términos 
                modificados.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">10. Ley Aplicable</h2>
              <p className="text-slate-600 mb-4">
                Estos Términos se regirán e interpretarán de acuerdo con las leyes del país donde 
                se preste el servicio, sin referencia a sus disposiciones sobre conflictos de leyes.
              </p>

              <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">11. Contacto</h2>
              <p className="text-slate-600 mb-4">
                Para cualquier pregunta sobre estos Términos de Servicio, puede contactarnos en:
              </p>
              <p className="text-slate-600">
                <strong>Email:</strong> legal@mercapolimove.com<br />
                <strong>Dirección:</strong> Ciudad de México, México
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
